<template>
    <label :id="labelId" class="relative z-20 block w-full p-12 bg-gray-100 hover:bg-white border border-gray-300 hover:border-gray focus:border-primary rounded text-lg text-gray-500 text-center transition-all duration-300" :class="{'cursor-pointer': !loading }">
        <v-loader v-if="loading"></v-loader>
        <template v-else>
            <div class="mb-4">
                <i class="fas fa-cloud-upload-alt opacity-50 text-4xl"></i>
            </div>
            <slot name="text">
                <span v-if="multiple">{{ $t('form.labels.image_uploader_button_multiple') }}</span>
                <span v-else>{{ $t('form.labels.image_uploader_button') }}</span>
            </slot>
            <input
                :id="inputId"
                type="file"
                class="absolute z-10 inset-0 block w-full opacity-0"
                :required="required"
                ref="uploader"
                @change.prevent="ensurePotentialReplacement"
                :multiple="multiple"
            />
        </template>
    </label>
</template>

<script>
    import Loader from '../_Partials/Loader.vue';
    export default {
        components: {
            'v-loader': Loader
        },
        props: {
            loading: {
                type: Boolean,
                default: false
            },
            inputId: {
                type: String,
                default: ''
            },
            labelId: {
                type: String,
                default: ''
            },
            multiple: {
                type: Boolean,
                default: false
            },
            multipleValues: {
                type: Boolean,
                required: true
            },
            havingValue: {
                type: Boolean,
                required: true,
            },
            required: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            getFiles()
            {
                return this.$refs.uploader.files;
            },

            getFile()
            {
                return this.$refs.uploader.files[0];
            },
            ensurePotentialReplacement()
            {
                if (this.havingValue 
                    && this.multipleValues === false 
                    && !window.confirm(this.$t('form.messages.image_uploader_confirm_image_replacement'))) {
                        document.getElementById(this.inputId).value = null;
                } else {
                    this.$emit('upload');
                }
            }
        }
    }
</script>
